import type { DashboardTemplate } from './dashboardTemplate.types';

// A full 3x3 grid of totals cards — nine components, which is the ceiling the generation system
// prompt states ("4 to 9 components is the useful range").
//
// The nine metrics are chosen to exercise every aggregation strategy that resolves today, so this
// template alone demonstrates the whole data path: `sum` (the seven currency figures), `ratio` (moic,
// recomputed as the summed total_value over the summed invested_capital) and `weighted_average`
// (gross_irr, weighted by invested capital). They also cover both TotalsCard footer styles — a
// currency card shows the grey delta plus a green percent, moic shows the single green multiple.
//
// `prior period` and not `entry`: entry is the cost basis and is unsupported for equity_value, which
// is a whole-company valuation rather than the fund's position.
export const totalsTemplate: DashboardTemplate = {
  id: 'totals',
  title: 'Portfolio KPI Totals',
  description: 'Nine headline metrics in a full 3x3 grid of KPI cards.',
  prompt: `Build a KPI dashboard of totals cards only — no charts, no tables, no content cards. Use a 3-column layout and make every card 1x1 with an accent bar and a "vs prior period" comparison.

One card each for: total value, invested capital, realized value, unrealized value, MOIC, gross IRR, total revenue, EBITDA, and equity value.`,
  preview: [
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
    { w: 1 },
  ],
};
